<script setup>
import { ref, onMounted } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAutomation } from 'dashboard/composables/useAutomation';
import AutomationRuleForm from './AutomationRuleForm.vue';

const emit = defineEmits(['saveAutomation']);

const START_VALUE = {
  name: null,
  description: null,
  event_name: 'conversation_created',
  conditions: [{
    attribute_key: 'status',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  }],
  actions: [{ action_name: 'assign_agent', action_params: [] }],
};

const store = useStore();
const formRef = ref(null);

const {
  automation,
  automationTypes,
  onEventChange,
  getConditionDropdownValues,
  appendNewCondition,
  appendNewAction,
  removeFilter,
  removeAction,
  resetAction,
  getActionDropdownValues,
  manifestCustomAttributes,
} = useAutomation(START_VALUE);

const open = () => {
  automation.value = structuredClone(START_VALUE);
  manifestCustomAttributes();
  formRef.value?.open();
};
const close = () => formRef.value?.close();
const onSave = (payload, mode) => emit('saveAutomation', payload, mode);

onMounted(() => {
  const accountId = store.getters.getCurrentAccountId;
  store.dispatch('inboxes/get');
  store.dispatch('agents/get');
  store.dispatch('contacts/get');
  store.dispatch('teams/get');
  store.dispatch('labels/get');
  store.dispatch('campaigns/get');
  store.dispatch('pipelines/get', { accountId }).catch(() => null);
  store.dispatch('dealLossReasons/get', { accountId }).catch(() => null);
});

defineExpose({ open, close });
</script>

<template>
  <AutomationRuleForm
    ref="formRef"
    v-model:automation="automation"
    mode="create"
    :automation-types="automationTypes"
    :get-condition-dropdown-values="getConditionDropdownValues"
    :get-action-dropdown-values="getActionDropdownValues"
    :append-new-condition="appendNewCondition"
    :append-new-action="appendNewAction"
    :remove-filter="removeFilter"
    :remove-action="removeAction"
    :reset-action="resetAction"
    :on-event-change="onEventChange"
    @save="onSave"
  />
</template>
